import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { CreateUserGroupScreenPath } from "./CreateUserGroupScreen.tsx";

export function useToCreateUserGroupScreen() {
  const navigate = useNavigate();

  const toCreateUserGroup = useCallback(() => {
    navigate(CreateUserGroupScreenPath);
  }, [navigate]);

  return { toCreateUserGroup };
}
